class StepDiagram2Controller {

  constructor($sce, $compile, $scope, $window) {
    'ngInject';

    this.pyramidBuilderIsActivated = false;
    this.isAnimationShowed = false

    Object.assign(this, {$sce, $compile, $scope, $window});
  }

  $postLink() {
    this.diagram = this.data;
    this.activeIndex = this.diagram.startStep || 0;
    setTimeout(() => {
      const diagramBody = angular.element(`#${this.diagram.id} .step__diagram-body`);
      diagramBody.html(this.diagram.diagram);
      this.$compile(diagramBody)(this.$scope);
      this.$scope.$apply();
    }, 200)

    // setTimeout(() => {
    //   const offsetTop = $('#' + this.diagram.id).offset().top;
    //   $(window).on('scroll', () => {
    //     const pagePosition = this.$window.scrollY + this.$window.innerHeight * 0.66
    //
    //     if (pagePosition >= offsetTop) {
    //       setTimeout(() => {
    //         this.showFirstSlide = true
    //         this.$scope.$apply()
    //       }, 500)
    //     }
    //   })
    // }, 300)
  }

  $onInit () {
    const interval = setInterval(() => {
      if (this.completed) {
        this.isAnimationShowed = true
        this.activeIndex = this.diagram.steps
        this.scrolled = true;
        clearInterval(interval)
        this.$scope.$apply();
      }
    }, 100)
  }

  moveSlide(number) {
    this.isAnimationShowed = true
    const newActiveIndex = this.activeIndex + number;
    if (newActiveIndex >= this.diagram.startStep && newActiveIndex <= this.diagram.steps) {
      this.activeIndex = newActiveIndex;
    }

    if (!this.pyramidBuilderIsActivated && this.activeIndex === newActiveIndex && this.diagram.steps === newActiveIndex ) {
      this.scrolled = false;

      $(window).on('scroll', () => {
        if (!this.scrolled) {
          this.onSubmit({ $event: this.diagram.pyramidData });
          this.scrolled = true;
          this.pyramidBuilderIsActivated = true;
          this.$scope.$apply();
        }
      })
    }

  }
}

export default StepDiagram2Controller;



// WEBPACK FOOTER //
// ./client/app/components/step-diagram-2/step-diagram-2.controller.js